import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Input,
  Spin,
  Form,
  Button,
  message,
  DatePicker,
} from 'antd';
import Table from 'components/Table';
import { getHistorialTramitesPrevios } from 'api/tramites';
import { DATE_FRONTEND_FORMAT } from 'utils/formatValues';
import { ArrowLeftOutlined } from '@ant-design/icons';

// eslint-disable-next-line react/prop-types
const HistorialPrevioDeTramites = ({ predio }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [tramiteSeleccionado, setTramiteSeleccionado] = useState(null);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      setLoading(true);
      try {
        const _data = await getHistorialTramitesPrevios({ predio });
        if (mounted) setData(_data);
      } catch (error) {
        if (mounted) {
          setData([]);
          message.error('Error al cargar el historial previo del predio');
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };

    if (predio) {
      fetchData();
    } else {
      setData([]);
    }

    return () => {
      mounted = false;
    };
  }, [predio]);

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const columns = [
    {
      titleText: 'Comprobante',
      dataIndex: 'comprobante',
      key: 'comprobante',
      width: 150,
      render: (text, record) => (
        <Button
          type="link"
          className="primary-text no-color"
          onClick={(e) => {
            e.preventDefault();
            setTramiteSeleccionado(record);
          }}
          disabled={loading}
        >
          <b>{text}</b>
        </Button>
      ),
    },
    {
      titleText: 'Asiento',
      dataIndex: 'numero_asiento',
      key: 'numero_asiento',
      width: 100,
    },
    {
      titleText: 'Tipo de trámite',
      dataIndex: 'tipo_tramite',
      key: 'tipo_tramite',
      width: 200,
    },
    {
      titleText: 'Movimiento',
      dataIndex: 'tipo_movimiento',
      key: 'tipo_movimiento',
      width: 150,
    },
    {
      titleText: 'Fecha',
      dataIndex: 'fecha_comprobante',
      key: 'fecha_comprobante',
      width: 100,
      render: (val) => val.format(DATE_FRONTEND_FORMAT),
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {tramiteSeleccionado ? (
          <Form layout="vertical" initialValues={tramiteSeleccionado}>
            <Row gutter={10}>
              <Col>
                <Button type="text" onClick={() => setTramiteSeleccionado()}>
                  <ArrowLeftOutlined />
                  Volver
                </Button>
              </Col>
              <Col span={24} />
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Comprobante" name="comprobante">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Asiento" name="numero_asiento">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Fecha" name="fecha_comprobante">
                  <DatePicker format={DATE_FRONTEND_FORMAT} disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Tipo de trámite" name="tipo_tramite">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Movimiento" name="tipo_movimiento">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Proceso" name="proceso">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Cuenta Única" name="numero_cuenta">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Clave Catastral" name="clave_catastral">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Subpredio" name="subpredio">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Titular" name="titular_predio">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={24} />
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Domicilio Titular" name="domicilio_titular">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Colonia" name="colonia_titular">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Municipio" name="municipio_titular">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Domicilio del Predio" name="ubicacion_predio">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Colonia" name="colonia_predio">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Municipio" name="ciudad_predio">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Área Título" name="area_titulo">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Superficie de Terreno" name="superficie_terreno">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Superficie de Construcción" name="superficie_construccion">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Perímetro" name="perimetro">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Profundidad" name="profundidad">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Frente" name="frente">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={6}>
                <Form.Item label="Distancia Esquina" name="distancia_esquina">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Valor Terreno" name="valor_terreno">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Valor Construcción" name="valor_construccion">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Valor Fiscal" name="valor_fiscal">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Bloques de Terreno" name="bloques_terreno">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Bloques de Construcción" name="bloques_construccion">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24}>
                <Form.Item label="Observaciones" name="observaciones">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Usuario Registró" name="usuario_registro">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Usuario Que Capturó" name="usuario_capturo">
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item label="Usuario Que Autorizó Pago" name="usuario_pago">
                  <Input disabled />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        ) : (
          <Table
            cols={columns}
            data={data}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            mobileColIndex={0}
            rowKey="id"
            allowSort={false}
            noControls
            hasAllViewPermission
          />
        )}
      </Spin>
    </Row>
  );
};

HistorialPrevioDeTramites.propTypes = {
  predio: PropTypes.number,
};

HistorialPrevioDeTramites.defaultProps = {
  predio: null,
};

export default HistorialPrevioDeTramites;
